'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = catalog;

var _constants = require('redux/constants');

var _utils = require('helpers/utils');

var _utils2 = require('../modules/catalog/utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    products: [],
    product_detail: {},
    categories: [],
    categoriesLoading: false,
    id: -1,
    title: '',
    count: 0,
    countAll: 0,
    categoryId: -1,
    activePage: 1,
    searchName: '',
    searchLoaded: false,
    searchProducts: [],
    limit: _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
    categorySeo: null,
    closeSearch: false,
    categoryRecommended: [],
    recommendedId: -1,
    categoryPreload: false,
    catalogIsLoaded: false,

    isCheckingForUpdates: false,
    checkForUpdateError: false,
    lastCatalogUpdateDate: null,
    hasUpdates: false,

    isRefreshingCatalog: false
};

function catalog() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    switch (action.type) {
        case _constants.CatalogConstants.LOAD_DETAIL:
        case _constants.CatalogConstants.LOAD_CATALOG:
        case _constants.CatalogConstants.LOAD:
            return state;

        case _constants.CatalogConstants.LOAD_CATEGORIES:
            return (0, _extends3.default)({}, state, {
                categoriesLoading: true
            });

        case _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES:
            return (0, _extends3.default)({}, state, {
                categoryPreload: true
            });

        case _constants.CatalogConstants.LOAD_BY_CATEGORIES:
            return (0, _extends3.default)({}, state, {
                categoryPreload: true
            });

        case _constants.CatalogConstants.LOAD_CATEGORIES_SUCCESS:
            var array = [].concat((0, _toConsumableArray3.default)(action.result));
            (0, _utils.sortCategoryBylength)(array);

            return (0, _extends3.default)({}, state, {
                catalogIsLoaded: true,
                categories: array,
                categoriesLoading: false,
                hasUpdates: false
            });

        case _constants.CatalogConstants.LOAD_SUCCESS:
            var products = [].concat((0, _toConsumableArray3.default)(action.result.offers));
            products = products.map(function (product_detail) {
                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
                        return (0, _utils2.addMinValueToOffer)(item);
                    });
                }
                return product_detail;
            });

            return (0, _extends3.default)({}, state, {
                products: products,
                count: action.result.count,
                countAll: action.result.countAll,
                limit: action.result.limit,
                activePage: action.result.activePage,
                searchName: action.result.searchName
            });

        case _constants.CatalogConstants.LOAD_CATALOG_SUCCESS:
            return (0, _extends3.default)({}, state);

        case _constants.CatalogConstants.LOAD_CATALOG_FAIL:
            return state;

        case _constants.CatalogConstants.LOAD_FAIL:
            return state;

        case _constants.CatalogConstants.LOAD_CATEGORIES_FAIL:
            return (0, _extends3.default)({}, state, {
                categoriesLoading: false
            });

        case _constants.CatalogConstants.LOAD_DETAIL_SUCCESS:
            var product_detail = (0, _extends3.default)({}, action.result);
            if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
                product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
                    return (0, _utils2.addMinValueToOffer)(item);
                });
            }
            return (0, _extends3.default)({}, state, {
                product_detail: product_detail
            });

        case _constants.CatalogConstants.LOAD_DETAIL_FAIL:
            return (0, _extends3.default)({}, state, {
                product_detail: {}
            });

        case _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_SUCCESS:
            products = [].concat((0, _toConsumableArray3.default)(action.result.offers));
            products = products.map(function (product_detail) {
                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
                        return (0, _utils2.addMinValueToOffer)(item);
                    });
                }
                return product_detail;
            });
            return (0, _extends3.default)({}, state, {
                products: products,
                title: action.result.title,
                description: action.result.description,
                picture: action.result.picture,
                id: action.result.id,
                count: action.result.count,
                limit: action.result.limit,
                activePage: action.result.activePage,
                categorySeo: action.result.seo,
                categoryPreload: false
            });

        case _constants.CatalogConstants.LOAD_BY_CATEGORIES_SUCCESS:
            products = [].concat((0, _toConsumableArray3.default)(action.result.offers));
            products = products.map(function (product_detail) {
                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
                        return (0, _utils2.addMinValueToOffer)(item);
                    });
                }
                return product_detail;
            });
            return (0, _extends3.default)({}, state, {
                id: action.result.id,
                products: products,
                title: action.result.title,
                description: action.result.description,
                picture: action.result.picture,
                limit: action.result.limit,
                count: action.result.count,
                categorySeo: action.result.seo,
                activePage: action.result.activePage,
                categoryPreload: false
            });

        case _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_FAIL:
            return (0, _extends3.default)({}, state, {
                categoryPreload: false
            });

        case _constants.CatalogConstants.LOAD_BY_CATEGORIES_FAIL:
            return (0, _extends3.default)({}, state, {
                categoryPreload: false
            });

        case _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD:
            return (0, _extends3.default)({}, state, {
                categoryRecommended: []
            });

        case _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                recommendedId: action.result.id,
                categoryRecommended: action.result.offers.map(function (item) {
                    return item.offer;
                })
            });

        case _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_FAIL:
            return (0, _extends3.default)({}, state);

        case _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD:
            return (0, _extends3.default)({}, state, {
                searchLoaded: true
            });

        case _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_SUCCESS:
            var searchProducts = [].concat((0, _toConsumableArray3.default)(action.result));
            searchProducts = searchProducts.map(function (product_detail) {
                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
                        return (0, _utils2.addMinValueToOffer)(item);
                    });
                }
                return product_detail;
            });
            return (0, _extends3.default)({}, state, {
                searchLoaded: false,
                searchProducts: searchProducts
            });

        case _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_FAIL:
            return (0, _extends3.default)({}, state, {
                searchLoaded: false
            });

        case _constants.CatalogConstants.SEARCH_PRODUCTS_RESET:
            return (0, _extends3.default)({}, state, {
                searchLoaded: false,
                searchProducts: []
            });

        case '@@router/LOCATION_CHANGE':

            return (0, _extends3.default)({}, state, {
                closeSearch: !/(\/search\/)/.test(action.payload.pathname)
            });

        case _constants.CatalogConstants.SET_SEARCH_CLOSE:
            return (0, _extends3.default)({}, state, {
                closeSearch: action.payload.close
            });
        case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE:
            return (0, _extends3.default)({}, state, {
                isCheckingForUpdates: true,
                updateCatalogError: false
            });
        case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                isCheckingForUpdates: false,
                updateCatalogError: false,
                lastCatalogUpdateDate: action.result,
                hasUpdates: state.hasUpdates ? state.hasUpdates : state.lastCatalogUpdateDate === null ? false : action.result !== state.lastCatalogUpdateDate

            });
        case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_FAIL:
            return (0, _extends3.default)({}, state, {
                isCheckingForUpdates: false,
                updateCatalogError: true
            });
        case _constants.CatalogConstants.REFRESH_CATALOG_LOAD:
            return (0, _extends3.default)({}, state, {
                isRefreshingCatalog: true
            });
        case _constants.CatalogConstants.REFRESH_CATALOG_LOAD_SUCCESS:
        case _constants.CatalogConstants.REFRESH_CATALOG_LOAD_FAIL:
            return (0, _extends3.default)({}, state, {
                isRefreshingCatalog: false
            });
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/catalog.js
// module id = 1897
// module chunks = 0